// src/contexts/AuthProvider.jsx
import React, { createContext, useEffect, useState } from "react";
import SignIn from "../Components/SignIn";
import { useAuth } from "../hooks/use-auth";
import { getAgentRTM, getToken } from "../utils/chat-sdk"; // <-- 改为新版 RTM 客户端
import { setAccessNameStore } from "../utils/store";
import { refreshAccessToken } from '../utils/auth-helper';

export const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const {
    isLoggedIn,
    accessToken,
    isLoading: authLoading,
    error,
    signInWithPopup,
    accountDetails,
  } = useAuth();

  const [isSDKReady, setIsSDKReady] = useState(false);
  const isLoading = authLoading || (isLoggedIn && !isSDKReady);

  // 1) 登录成功后连接 RTM，销毁时断开连接
  useEffect(() => {
    let isMounted = true

    const initRTM = async () => {
      try {
        if (isLoggedIn && accessToken) {
          const agentRTM = getAgentRTM()
          console.log("login-----", accessToken)
          await agentRTM.connect();
          const sessionUser = await agentRTM.login();

          setAccessNameStore(sessionUser?.my_profile?.id)


          // 自动监听 RTM token 失效，尝试重连
          agentRTM.on("disconnected", async (reason) => {
            console.warn("⚠️ RTM 断开:", reason);
            if (reason === "authentication_failed") {
              console.log("🔁 尝试刷新 token 并重连 RTM...");
              await agentRTM.connect(); // 会自动使用 tokenGetter 取新 token
              const sessionUser = await agentRTM.login();

              setAccessNameStore(sessionUser?.my_profile?.id)
            }
          });

          if (isMounted) setIsSDKReady(true)
        }
      } catch (e) {
        if (e.error.type == "authentication") {
          console.warn('authentication失败了')
          const newToken = await refreshAccessToken();
          if (newToken) {
            const agentRTM = getAgentRTM();
            await agentRTM.connect();
            const sessionUser = await agentRTM.login();
            setAccessNameStore(sessionUser?.my_profile?.id);
            setIsSDKReady(true);
          }
        }
        console.error('RTM 初始化失败:', e)
      }
    }

    initRTM()

    return () => {
      isMounted = false
      // 可选：断开 RTM 或清理状态
      // agentRTM.logout()
    }
  }, [isLoggedIn]);


  return (
    <AuthContext.Provider value={accountDetails}>
      {isLoggedIn && isSDKReady ? (
        children
      ) : (
        <SignIn
          isLoading={isLoading}
          error={error}
          openPopup={signInWithPopup}
        />
      )}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
